import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import Modal from '@tds/community-modal';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { businessConnectContactCentreOnlineTool } from '../../../utils/constant';
import { Button } from './css';

const Continue = ({ orderData, status }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { confirmationDialog, continueLabel, editOrder },
    formButtons: { confirmButtonLabel, cancelButtonLabel },
    callCentre: {
      salesRepDashboard: { confirmationToModifyTheOrder }
    }
  } = localizedStrings;
  const { locale, categoryName, id } = orderData;
  const history = useHistory();

  const getLabel = () => {
    let label;

    switch (status) {
      case 'Incomplete':
        label = continueLabel;
        break;
      case 'Submitted':
        label = editOrder;
        break;
      default:
        label = continueLabel;
    }
    return label;
  };

  const handleModifyQuote = () => {
    history.push({
      pathname: `/${locale}/${categoryName}/${businessConnectContactCentreOnlineTool}`,
      search: `?orderId=${id}`
    });
    window.location.reload();
  };

  return (
    <>
      <Button onClick={() => setIsModalOpen(true)}>{getLabel()}</Button>
      <Modal
        heading={confirmationDialog}
        bodyText={confirmationToModifyTheOrder}
        confirmCTAText={confirmButtonLabel}
        cancelCTAText={cancelButtonLabel}
        onConfirm={() => handleModifyQuote()}
        onClose={() => setIsModalOpen(false)}
        isOpen={isModalOpen}
      />
    </>
  );
};

Continue.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  status: PropTypes.string.isRequired
};

export default Continue;
